import * as React from "react";
import { useRef } from "react";
import { ChevronRight, ChevronLeft } from "@mui/icons-material";

import useStyles from "./styles";

interface DivScrollHorizontalProps {
  label?: string;
  children?: any;
  className?: string;
  onScroll?: () => void;
  id?: string;
}

const DivScrollHorizontal = ({
  label,
  children,
  className,
  onScroll,
  id,
}: DivScrollHorizontalProps) => {
  const styles = useStyles();
  const listScrollRef = useRef<HTMLDivElement>();

  const handleMoveScroll = (direction: -1 | 1) => {
    const { current } = listScrollRef;

    onScroll?.();

    if (current) {
      current.scrollTo({
        left: current.scrollLeft + 210 * direction,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={[styles.container, className].join(" ")} id={id}>
      <div className={styles.rowTitle}>
        <h3 className={styles.title}>{label}</h3>
        <div className={styles.rowNavigation}>
          <button
            className={styles.buttonNavigation}
            onClick={() => handleMoveScroll(-1)}
          >
            <ChevronLeft />
          </button>
          <button
            className={styles.buttonNavigation}
            onClick={() => handleMoveScroll(1)}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
      <div className={styles.rowItems} ref={listScrollRef} onScroll={onScroll}>
        {children}
      </div>
    </div>
  );
};

export default DivScrollHorizontal;
